import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BRAND } from "@/config/content";

export const usePublicConfig = () => {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get("/public-config").then((r) => setCfg(r.data)).catch(() => setCfg({}));
  }, []);
  return cfg;
};

export const Header = ({ right, classic }) => (
  <header className="relative z-10 mx-auto flex max-w-5xl items-center justify-between px-5 py-5 sm:px-8">
    <Link to="/" data-testid="header-home-link" className="flex items-center gap-2.5">
      {classic
        ? <span className="flex h-8 w-8 items-center justify-center rounded-full border border-stone-800 font-display text-[13px]">360</span>
        : <img src="/img/logo-simbolo.png" alt="" width="40" height="40" className="-my-1 h-10 w-10 rounded-full object-cover" data-testid="header-logo" />}
      <span className="text-sm font-semibold tracking-wide text-stone-800">{BRAND.school}</span>
    </Link>
    {right}
  </header>
);

export const Footer = () => {
  const cfg = usePublicConfig();
  return (
    <footer className="relative z-10 mt-24 border-t border-stone-200/80" data-testid="site-footer">
      <div className="mx-auto flex max-w-5xl flex-col gap-6 px-5 py-10 text-sm text-stone-600 sm:flex-row sm:justify-between sm:px-8">
        <div>
          <p className="font-display text-base text-stone-800">{BRAND.product}</p>
          <p className="mt-1">{BRAND.concept}</p>
        </div>
        <div className="flex flex-col gap-2 sm:items-end">
          <div className="flex gap-5">
            <Link to="/privacidade" data-testid="footer-privacy-link" className="hover:text-stone-900">Política de privacidade</Link>
            <Link to="/termos" data-testid="footer-terms-link" className="hover:text-stone-900">Termos de uso</Link>
            <Link to="/recuperar-acesso" data-testid="footer-recover-link" className="hover:text-stone-900">Recuperar acesso</Link>
          </div>
          <p data-testid="footer-contact" className="flex flex-wrap gap-x-1">
            <span>Contato:</span>{cfg?.contact_email || cfg?.contact_whatsapp
              ? [cfg.contact_email, cfg.contact_whatsapp].filter(Boolean).map((c, i) => (
                <span key={c} className="whitespace-nowrap">{i > 0 && " · "}{c}</span>
              ))
              : "[contato a configurar]"}
          </p>
        </div>
      </div>
    </footer>
  );
};

export const Page = ({ children, headerRight, classicLogo }) => (
  <div className="grain min-h-screen">
    <Header right={headerRight} classic={classicLogo} />
    <main className="relative z-10">{children}</main>
    <Footer />
  </div>
);
